import { normalizeSortMode } from './searchScope';

// Skeleton markup shown while the alternate scope fetch is still in flight.
export default function buildScopeSkeletonMarkup(scope, siteName, sortMode, rowCount = 4) {
  const resultsFromLabel = scope === 'site' && siteName
    ? siteName
    : window.gettext('the Informa TechTarget Network');
  const normalizedSortMode = normalizeSortMode(sortMode);
  const isDateMode = normalizedSortMode === 'date';
  // Keep loading rows equal to current results so ad spots do not jump around.
  const skeletonRowCount = Math.max(parseInt(rowCount, 10) || 0, 4);
  const topCards = [0, 1, 2].map(() => (
    `<li class="semantic-search-skeleton-card" aria-hidden="true">
      <div class="semantic-search-skeleton-card__meta">
        <div class="semantic-search-skeleton__logo"></div>
        <div class="semantic-search-skeleton__line semantic-search-skeleton__line--meta"></div>
      </div>
      <div class="semantic-search-skeleton__line semantic-search-skeleton__line--title semantic-search-skeleton__line--long"></div>
      <div class="semantic-search-skeleton__line semantic-search-skeleton__line--body semantic-search-skeleton__line--medium"></div>
      <div class="semantic-search-skeleton__line semantic-search-skeleton__line--body semantic-search-skeleton__line--short"></div>
    </li>`
  )).join('');
  const feedItems = Array.from({ length: skeletonRowCount }).map(() => (
    `<li class="row feed__item semantic-remaining-result semantic-search-skeleton-feed-item" aria-hidden="true" data-relevance-order="0" data-date-sort-ms="0">
      <div class="semantic-search-skeleton__line semantic-search-skeleton-feed-item__label"></div>
      <div class="semantic-search-skeleton__line semantic-search-skeleton-feed-item__title"></div>
      <div class="semantic-search-skeleton__line semantic-search-skeleton-feed-item__description"></div>
      <div class="semantic-search-skeleton__line semantic-search-skeleton-feed-item__description"></div>
      <div class="semantic-search-skeleton__line semantic-search-skeleton__line--meta"></div>
    </li>`
  )).join('');

  return `
    <section
      class="semantic-search-results semantic-search-top-results js-semantic-search-scope-skeleton"
      aria-label="${window.gettext('Loading top search results')}"
      aria-busy="true"
    >
      <div class="semantic-search-section__header">
        <div class="semantic-search-section__title-block">
          <h2 class="dash-header">${window.gettext('Top Matches')}</h2>
        </div>
      </div>
      <ul class="semantic-search-cards">${topCards}</ul>
    </section>
    <section
      class="semantic-remaining-results js-semantic-remaining-results js-semantic-search-scope-skeleton"
      aria-label="${window.interpolate(window.gettext('Loading results from %(source)s'), { source: resultsFromLabel }, true)}"
      aria-busy="true"
    >
      <div class="semantic-search-section__header">
        <div class="semantic-search-section__title-block">
          <h2 class="dash-header">${window.interpolate(window.gettext('Results from %(source)s'), { source: resultsFromLabel }, true)}</h2>
        </div>
        <div class="sort-mode-toggle" role="group" aria-label="${window.gettext('Sort remaining results')}">
          <button type="button" class="sort-mode-toggle__btn${isDateMode ? '' : ' is-active'}" data-sort-mode="relevance" disabled>${window.gettext('By relevance')}</button>
          <button type="button" class="sort-mode-toggle__btn${isDateMode ? ' is-active' : ''}" data-sort-mode="date" disabled>${window.gettext('By date')}</button>
        </div>
      </div>
      <ul class="feed layout-stack-xxl semantic-remaining-results__list semantic-search-feed">${feedItems}</ul>
    </section>
  `;
}
